<div class="perfil-list">
  <app-back-button data-testid="perfil-list-voltar" (back)="voltar()" />

  <app-page-header title="Perfis" subtitle="Gerencie os perfis de investimento disponíveis.">
    <ng-container actions>
      <button
        type="button"
        class="btn-secondary btn-toolbar"
        data-testid="btn-configuracoes"
        (click)="onConfiguracoes()"
      >Configurações</button>
      <button
        type="button"
        class="btn-primary btn-toolbar"
        data-testid="btn-criar-perfil"
        (click)="criarPerfil()"
      >Criar Perfil</button>
    </ng-container>
  </app-page-header>

  <app-filter-bar [fields]="filterFields" (filtersChange)="onFiltersChange($event)" />

  <section aria-labelledby="perfil-list-section-title">
    <h2 id="perfil-list-section-title" class="perfil-list__section-title">
      Perfis Criados
    </h2>

    @if (perfis().length === 0) {
      <app-empty-state message="Nenhum perfil encontrado" />
    } @else {
      <app-data-table ariaLabel="Perfis criados">
        <thead>
          <tr>
            <th scope="col">Nome do Perfil</th>
            <th scope="col">Status</th>
            <th scope="col">Última Atualização</th>
            <th scope="col" class="perfil-list__actions-head">
              <span class="perfil-list__sr-only">Ações</span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (perfil of perfisPaginados(); track perfil.id) {
            <tr>
              <td>
                <button
                  type="button"
                  class="table-link perfil-list__name-btn"
                  data-testid="perfil-link"
                  (click)="visualizarPerfil(perfil.id)"
                >
                  {{ perfil.nome }}
                </button>
              </td>
              <td>
                <app-status-badge [status]="perfil.status" data-testid="perfil-status" />
              </td>
              <td>{{ formatDate(perfil.ultimaAtualizacao) }}</td>
              <td class="perfil-list__actions-cell">
                <div
                  class="perfil-list__actions-menu"
                  [class.perfil-list__actions-menu--open]="menuAbertoId() === perfil.id"
                >
                  <button
                    type="button"
                    class="actions-menu-btn"
                    [attr.aria-expanded]="menuAbertoId() === perfil.id"
                    aria-haspopup="true"
                    [attr.aria-label]="'Ações para ' + perfil.nome"
                    data-testid="perfil-actions-menu-btn"
                    (click)="toggleMenu(perfil.id, $event)"
                  >
                    &#8942;
                  </button>
                  @if (menuAbertoId() === perfil.id) {
                    <div
                      class="perfil-list__actions-dropdown actions-menu-dropdown--fixed"
                      role="menu"
                      [style.top.px]="menuPosition()?.top"
                      [style.right.px]="menuPosition()?.right"
                    >
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="perfil-action-visualizar"
                        (click)="visualizarPerfil(perfil.id)"
                      >
                        Visualizar Perfil
                      </button>
                      <button
                        type="button"
                        role="menuitem"
                        data-testid="perfil-action-editar"
                        (click)="editarPerfil(perfil.id)"
                      >
                        Editar Perfil
                      </button>
                      <button
                        type="button"
                        role="menuitem"
                        class="perfil-list__actions-dropdown-danger"
                        data-testid="perfil-action-excluir"
                        (click)="abrirConfirmacaoExclusao(perfil)"
                      >
                        Excluir Perfil
                      </button>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </app-data-table>

      <app-pagination
        [currentPage]="currentPage()"
        [pageSize]="pageSize"
        [totalItems]="perfis().length"
        (pageChange)="onPageChange($event)"
      />
    }
  </section>

  @if (perfilVisualizado(); as perfil) {
    <app-perfil-visualizar-modal
      [perfil]="perfil"
      (fechar)="fecharVisualizacao()"
      (editar)="editarPerfilVisualizado($event)"
    />
  }

  @if (showDeleteDialog) {
    <app-alert-dialog
      title="Excluir Perfil"
      message="Tem certeza que deseja excluir este perfil?"
      description="Essa ação removerá permanentemente o perfil selecionado e não poderá ser desfeita."
      cancelLabel="Cancelar"
      confirmLabel="Excluir"
      [showConfirmIcon]="false"
      (cancel)="cancelarExclusao()"
      (confirm)="confirmarExclusao()"
    />
  }
</div>
